/**
 * Options handed to LogRocket.init in app/javascript/packs/application.js.
 *
 * Kept out of the pack so they can be unit-tested (the pack requires
 * channels, trix, ActiveStorage and the SCSS bundle, none of which load
 * under Jest) and so every LogRocket option lands in one place.
 */

import { createLogRocketSanitizer } from "./log_rocket_sanitizer"

/**
 * LogRocket's CDN recorder (verified against logger.min.js 26.385.0) writes
 * its _lr_hb_* and _lr_tabs_* cookies with SameSite=Lax and no Secure flag by
 * default. The only option that adds Secure is cookiePolicy "crossSite",
 * which emits SameSite=None; Secure when the page is served over https and
 * falls back to the Lax default on http, so development is unaffected.
 * Those cookies hold a recording id and a heartbeat timestamp, no auth, so
 * SameSite=None is an accepted trade-off (Qualys QID 150122, project #1481).
 *
 * @returns {{network: {requestSanitizer: Function, responseSanitizer: Function}, cookiePolicy: string}}
 */
export function logRocketInitOptions() {
  return {
    network: createLogRocketSanitizer(),
    cookiePolicy: "crossSite"
  }
}
